<!-- 尤溪单点登录 -->
<template>
  <div class="login-wrap">
    <div class="main">
			<div class="recom">单点登录中，请稍后...</div>
		</div>
  </div>
</template>


<script>
import api from '@/service/api';
import dayjs from 'dayjs';

export default {
	data(){
		return {
			isLoading: false,
			captchaSrc:'',
			form: {username: '', password: ''},
			hospitalId:0
		}
	},
	async created(){
		let query = this.$route.query;
		if (Object.keys(query).length != 0) {
			query = JSON.stringify(this.$route.query);
			let res = await api.ssoLogin({params:query})
			if (res.code != 1000) {
				this.$message({message:res.message,duration:"0",type:"error"})
				return;
			}
			let user = {data: res.data, expire: +dayjs().add(7, 'day')};
			localStorage.setItem('user', JSON.stringify(user));
			this.$router.push({ name: 'Home' });
		}else{
			this.$message({message:"单点登录参数不全，请关闭页面后，重新进入",duration:"0",type:"error"});
		}
	},
	methods: {
	}
}
</script>

<style lang="less">
@import '@/assets/style/var';

body {background-color: rgba(246,246,246,1);}
.login-wrap {
	position: relative;
	width: 100vw;
	height: 100vh;
	.main {
		position: absolute;
		top: 48%;
		left: 50%;
		width: 500px;
		text-align: center;
		transform: translate3d(-50%, -50%, 0);
		.logo {
			i {color: @fckey; font-size: 84px;}
		}
		.title {
			height: 31px;
			margin: 10px 0 50px;
			background: 50% 50% url('../../assets/images/login-1.png?v=@{v}') no-repeat;
			background-size: auto 31px;
		}
	}
	.recom {margin-bottom: 20px; color: #CCC; font-size: 18px;}
}
</style>